var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgEvents = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-navi-events",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(1.000000, 0.000000)",
    stroke: "#0084F8",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-1",
    points: "-7.28306304e-13 21.6984 20.475 21.6984 20.475 2.3824 -7.28306304e-13 2.3824"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-7",
    points: "6.374 14.6161 9.916 18.1571 14.809 9.2721"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2.84217094e-14,
    y1: 6.5678,
    x2: 20.411,
    y2: 6.5678,
    id: "Stroke-5"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3.6699,
    y1: 4.765,
    x2: 3.6699,
    y2: -6.39488462e-14,
    id: "Stroke-3"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16.7402,
    y1: 4.765,
    x2: 16.7402,
    y2: -6.39488462e-14,
    id: "Stroke-4"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEvents, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/events.790d53cd.svg";
export { ForwardRef as ReactComponent };